if (process.env.NODE_ENV !== 'production') {
    console.error('@skbkontur/icons: Importing from the root `index.js` is not recommended.' +
        '\nSee https://www.npmjs.com/package/@skbkontur/icons?activeTab=readme');
}
export * from './ArchiveBoxIcon';
export * from './ArchiveBoxOpenDocsIcon';
export * from './ArchiveCabinetIcon';
export * from './ArrowADownIcon';
export * from './ArrowADownLeftIcon';
export * from './ArrowADownRightIcon';
export * from './ArrowALeftIcon';
export * from './ArrowARightIcon';
export * from './ArrowAUpIcon';
export * from './ArrowAUpLeftIcon';
export * from './ArrowAUpRightIcon';
export * from './ArrowCDownIcon';
export * from './ArrowCLeftIcon';
export * from './ArrowCRightIcon';
export * from './ArrowCUpIcon';
export * from './ArrowFigureACircleDownIcon';
export * from './ArrowFigureACircleLeftIcon';
export * from './ArrowFigureACircleRightIcon';
export * from './ArrowFigureACircleUpIcon';
export * from './ArrowFigureASquareDownIcon';
export * from './ArrowFigureASquareLeftIcon';
export * from './ArrowFigureASquareRightIcon';
export * from './ArrowFigureASquareUpIcon';
export * from './ArrowParallelHIcon';
export * from './ArrowParallelVIcon';
export * from './ArrowRoundSyncForwardIcon';
export * from './ArrowRoundTimeBackIcon';
export * from './ArrowRoundTimeForwardIcon';
export * from './ArrowUiAuthLoginIcon';
export * from './ArrowUiAuthLogoutIcon';
export * from './ArrowUiCornerOutUpRightIcon';
export * from './ArrowUiShareAExportIcon';
export * from './ArrowUiShareAImportIcon';
export * from './AttachLinkIcon';
export * from './AttachLinkOffIcon';
export * from './AttachPaperclipIcon';
export * from './BagBriefcaseIcon';
export * from './BlockIcon';
export * from './BookClosedGovIcon';
export * from './BookClosedHelpIcon';
export * from './BookClosedIcon';
export * from './BookmarkIcon';
export * from './BookNotepadIcon';
export * from './BookNotepadSpiralIcon';
export * from './BookOpenIcon';
export * from './BookOpenTextIcon';
export * from './BooksLibraryIcon';
export * from './BuildingHomeIcon';
export * from './BuildingOfficeIcon';
export * from './CalculatorIcon';
export * from './CalendarIcon';
export * from './CertRosetteIcon';
export * from './CheckAIcon';
export * from './CheckCircleCutIcon';
export * from './CheckCircleIcon';
export * from './CheckSquareCutIcon';
export * from './CheckSquareIcon';
export * from './CommentRectIcon';
export * from './CommentRectPlusIcon';
export * from './CommentRectTextIcon';
export * from './CommentRectXIcon';
export * from './CopyIcon';
export * from './CounterIcon';
export * from './DeliveryBoxFrontOpenIcon';
export * from './DivideCircleIcon';
export * from './DivideIcon';
export * from './DocCheckIcon';
export * from './DocIcon';
export * from './DocMinusIcon';
export * from './DocPlusIcon';
export * from './DocsPlusIcon';
export * from './DocsTextIcon';
export * from './DocTextIcon';
export * from './DocXIcon';
export * from './EyeClosedIcon';
export * from './EyeOffIcon';
export * from './EyeOpenIcon';
export * from './FaceAHappyIcon';
export * from './FaceASadIcon';
export * from './FlagAIcon';
export * from './FlagBIcon';
export * from './FolderIcon';
export * from './FoodDrinkCupHotIcon';
export * from './GovKoFssIcon';
export * from './HeartIcon';
export * from './IdCardIcon';
export * from './InfoCircleIcon';
export * from './InfoSquareIcon';
export * from './JewelCrownIcon';
export * from './KonturMercuryIcon';
export * from './LightbulbIcon';
export * from './LightbulbOnIcon';
export * from './LocationGlobeIcon';
export * from './LocationPinIcon';
export * from './LogoFacebookIcon';
export * from './LogoInstagramIcon';
export * from './LogoOkIcon';
export * from './LogoTelegramIcon';
export * from './LogoTwitterIcon';
export * from './LogoViberIcon';
export * from './LogoVkIcon';
export * from './LogoWhatsappIcon';
export * from './LogoYandexZenIcon';
export * from './LogoYoutubeIcon';
export * from './MailIcon';
export * from './MarketReceiptIcon';
export * from './MarketRegisterClassicIcon';
export * from './MarketShoppingBasketIcon';
export * from './MarketShoppingCartIcon';
export * from './MathFunctionIcon';
export * from './MathFunctionOffIcon';
export * from './MathInfinityIcon';
export * from './MedBriefcaseIcon';
export * from './MediaPictureIcon';
export * from './MinusCircleIcon';
export * from './MinusIcon';
export * from './MinusSquareIcon';
export * from './MoneyTypeCardIcon';
export * from './MoneyTypeCoinsIcon';
export * from './NetDownloadIcon';
export * from './NetUploadIcon';
export * from './NotificationBellAlarmIcon';
export * from './NotificationBellIcon';
export * from './NotificationBellOffIcon';
export * from './PlusCircleIcon';
export * from './PlusIcon';
export * from './PlusSquareIcon';
export * from './QuestionCircleIcon';
export * from './QuestionSquareIcon';
export * from './SearchLoupeIcon';
export * from './SearchLoupeMinusIcon';
export * from './SearchLoupePlusIcon';
export * from './SecurityKeyAIcon';
export * from './SecurityKeyBIcon';
export * from './SecurityLockClosedIcon';
export * from './SecurityLockOpenIcon';
export * from './SecurityShieldCheckIcon';
export * from './SecurityShieldIcon';
export * from './SendPaperplaneDiagIcon';
export * from './SendPaperplaneIcon';
export * from './SettingsGearIcon';
export * from './ShapeCircleIcon';
export * from './ShapeRectHIcon';
export * from './ShapeRectVIcon';
export * from './ShapeSquareIcon';
export * from './StackHDownIcon';
export * from './StarHalfIcon';
export * from './StarIcon';
export * from './TagIcon';
export * from './TechCamPhotoIcon';
export * from './TechPcLaptopIcon';
export * from './TechPhoneClassicIcon';
export * from './TechPhoneSmartIcon';
export * from './TechPrinterIcon';
export * from './TechScreenGenericIcon';
export * from './TechServerIcon';
export * from './TechStorageUsbIcon';
export * from './TimeClockFastIcon';
export * from './TimeClockIcon';
export * from './TimeClockMoveBackIcon';
export * from './TimeClockMoveForwardIcon';
export * from './ToolPencilIcon';
export * from './ToolPencilLineIcon';
export * from './ToolPencilSquareIcon';
export * from './TransportAutoCarFrontIcon';
export * from './TrashCanIcon';
export * from './UiFilterFunnelIcon';
export * from './UiFilterListIcon';
export * from './UiFilterSortADefaultIcon';
export * from './UiFilterSortAHighToLowIcon';
export * from './UiFilterSortALowToHighIcon';
export * from './UiLoadSpinnerIcon';
export * from './UiWindowNewDownRightIcon';
export * from './UiWindowNewUpRightIcon';
export * from './WarningCircleIcon';
export * from './WarningTriangleIcon';
export * from './XCircleIcon';
export * from './XIcon';
export * from './XSquareIcon';
export * from './ArrowCollapseCHClosedIcon';
export * from './ArrowCollapseCHOpenIcon';
export * from './ArrowCollapseCVClosedIcon';
export * from './ArrowCollapseCVOpenIcon';
export * from './ArrowCollapseTrianglesHClosedIcon';
export * from './ArrowCollapseTrianglesHOpenIcon';
export * from './ArrowCollapseTrianglesVClosedIcon';
export * from './ArrowCollapseTrianglesVOpenIcon';
export * from './ArrowShapeADownIcon';
export * from './ArrowShapeADownLeftIcon';
export * from './ArrowShapeADownRightIcon';
export * from './ArrowShapeALeftIcon';
export * from './ArrowShapeARightIcon';
export * from './ArrowShapeAUpIcon';
export * from './ArrowShapeAUpLeftIcon';
export * from './ArrowShapeAUpRightIcon';
export * from './ArrowShapeDRadiusDownLeftIcon';
export * from './ArrowShapeDRadiusDownRightIcon';
export * from './ArrowShapeDRadiusUpLeftIcon';
export * from './ArrowShapeDRadiusUpRightIcon';
export * from './ArrowShapeTriangleADownIcon';
export * from './ArrowShapeTriangleALeftIcon';
export * from './ArrowShapeTriangleARightIcon';
export * from './ArrowShapeTriangleAUpIcon';
export * from './DataChartBarsAIcon';
export * from './DataChartBarsXIcon';
export * from './DataChartTrendXyUpIcon';
export * from './DevBugIcon';
export * from './DocArrowConvertIcon';
export * from './DocArrowSyncIcon';
export * from './EduHatIcon';
export * from './FaceANeutralIcon';
export * from './GovLawScalesIcon';
export * from './HandThumbDownIcon';
export * from './HandThumbUpIcon';
export * from './MailArrowInIcon';
export * from './MailArrowOutIcon';
export * from './MediaAudioHeadphonesIcon';
export * from './MediaAudioHeadsetIcon';
export * from './MediaUiAEjectIcon';
export * from './MediaUiAPauseIcon';
export * from './MediaUiAPauseShapeIcon';
export * from './MediaUiAPlayForwardIcon';
export * from './MediaUiAPlayIcon';
export * from './MediaUiAPlayPauseIcon';
export * from './MediaUiARecordIcon';
export * from './MediaUiARewindBackIcon';
export * from './MediaUiARewindForwardIcon';
export * from './MediaUiASkipBackIcon';
export * from './MediaUiASkipForwardIcon';
export * from './MediaUiAStopIcon';
export * from './MediaUiCirclePauseIcon';
export * from './MediaUiCirclePlayIcon';
export * from './MediaUiRectPlayIcon';
export * from './MegaphoneIcon';
export * from './MoneyCurrencyRubleCircleIcon';
export * from './MoneyCurrencyRubleIcon';
export * from './MoneyCurrencyRubleRectIcon';
export * from './MoneyWalletAIcon';
export * from './MoneyWalletAOpenIcon';
export * from './ShareNetworkIcon';
export * from './TimeHourglassIcon';
export * from './ToolMagicWandIcon';
export * from './AttachPinIcon';
export * from './MathDeltaIcon';
export * from './MathSumIcon';
export * from './NetCloudArrowDownloadIcon';
export * from './NetCloudArrowUploadIcon';
export * from './NetCloudCheckIcon';
export * from './NetCloudIcon';
export * from './NetCloudWireIcon';
export * from './DocsIcon';
export * from './FolderCheckIcon';
export * from './FolderMinusIcon';
export * from './FolderPlusIcon';
export * from './FolderSharedIcon';
export * from './FoldersIcon';
export * from './FolderXIcon';
export * from './FoodDrinkAlcoBottleWineIcon';
export * from './FoodDrinkAlcoGlassBeerIcon';
export * from './FoodDrinkAlcoGlassCocktailIcon';
export * from './FoodDrinkAlcoGlassWineIcon';
export * from './NewsFeedIcon';
export * from './ShapeTriangleUpIcon';
export * from './TextActionCheckIcon';
export * from './TextActionPlusIcon';
export * from './TextAlignCenterIcon';
export * from './TextAlignCenterJustifyIcon';
export * from './TextAlignLeftIcon';
export * from './TextAlignLeftJustifyIcon';
export * from './TextAlignRightIcon';
export * from './TextAlignRightJustifyIcon';
export * from './TextBulletChecklistIcon';
export * from './TextBulletGroupIcon';
export * from './TextBulletIcon';
export * from './TextBulletNumbersIcon';
export * from './ToolHardHammersIcon';
export * from './AwardCupIcon';
export * from './AwardMedalIcon';
export * from './CelebrationGiftBoxIcon';
export * from './FileFormatBmpIcon';
export * from './FileFormatCsvIcon';
export * from './FileFormatDocIcon';
export * from './FileFormatFdIcon';
export * from './FileFormatFrdIcon';
export * from './FileFormatHtmlIcon';
export * from './FileFormatJpgIcon';
export * from './FileFormatPdfIcon';
export * from './FileFormatPngIcon';
export * from './FileFormatRtfIcon';
export * from './FileFormatTxtIcon';
export * from './FileFormatXlsIcon';
export * from './FileFormatXmlIcon';
export * from './FileTypeArchiveIcon';
export * from './FileTypeMarkupIcon';
export * from './FileTypePdfIcon';
export * from './FileTypePictureIcon';
export * from './FileTypePresentationIcon';
export * from './FileTypeTableIcon';
export * from './FileTypeTextIcon';
export * from './LogoFigmaIcon';
export * from './ScanBarcodeClassicIcon';
export * from './ScanBarcodeDatamatrixIcon';
export * from './ScanBarcodeQrIcon';
export * from './ScanFrameActionCheckIcon';
export * from './ScanFrameActionPlusIcon';
export * from './ScanFrameBarcodeClassicIcon';
export * from './ScanFrameIcon';
export * from './ScanFramePeopleIcon';
export * from './ScanFrameTextIcon';
export * from './ToolHardWrenchIcon';
export * from './MarketRegisterScannerIcon';
export * from './DeliveryBoxIsoClosedIcon';
export * from './DeliveryBoxIsoIcon';
export * from './DevCodeIcon';
export * from './ShapeCircleMDashIcon';
export * from './ShapeCircleMIcon';
export * from './ShapeCircleMOffIcon';
export * from './ShapeCircleSIcon';
export * from './ArrowDCornerDownLeftIcon';
export * from './ArrowDCornerDownRightIcon';
export * from './ArrowDCornerLeftDownIcon';
export * from './ArrowDCornerLeftUpIcon';
export * from './ArrowDCornerRightDownIcon';
export * from './ArrowDCornerRightUpIcon';
export * from './ArrowDCornerUpLeftIcon';
export * from './ArrowDCornerUpRightIcon';
export * from './ArrowDRadiusDownLeftIcon';
export * from './ArrowDRadiusDownRightIcon';
export * from './ArrowDRadiusUpLeftIcon';
export * from './ArrowDRadiusUpRightIcon';
export * from './ArrowDUturnLeftDownIcon';
export * from './ArrowDUturnLeftUpIcon';
export * from './ArrowDUturnRightDownIcon';
export * from './ArrowDUturnRightUpIcon';
export * from './ArrowDUturnUpLeftIcon';
export * from './ArrowDUturnUpRightIcon';
export * from './BuildingGovIcon';
export * from './CertLicenseIcon';
export * from './LogoAndroidIcon';
export * from './LogoAppleIcon';
export * from './DocArrowInIcon';
export * from './DocArrowOutIcon';
export * from './DocEditIcon';
export * from './MailOffIcon';
export * from './AnimalPawIcon';
export * from './ArrowDim1DiagLeftIcon';
export * from './ArrowDim1DiagRightIcon';
export * from './ArrowDim1HIcon';
export * from './ArrowDim1VIcon';
export * from './ArrowDim2DiagMaxRightIcon';
export * from './ArrowDim2DiagMinRightIcon';
export * from './ArrowDim4DiagMaxIcon';
export * from './ArrowDim4DiagMinIcon';
export * from './BuildingOfficeAltIcon';
export * from './BuildingOfficeFlagIcon';
export * from './CheckA2Icon';
export * from './ChildBabyIcon';
export * from './ChildPacifierIcon';
export * from './ClothesHangerIcon';
export * from './ClothesOuterTshirtIcon';
export * from './CommentRect2TextIcon';
export * from './DataChartBarsAUpIcon';
export * from './DataChartBarsXUpIcon';
export * from './DataChartBarsXyVIcon';
export * from './DataChartBarsXyVUpIcon';
export * from './DataChartPieA1Icon';
export * from './DataChartPieA2Icon';
export * from './DevRobotIcon';
export * from './HousewareSprayIcon';
export * from './KonturInstallIcon';
export * from './LogoMicrosoftIcon';
export * from './MediaAudioSpeakerIcon';
export * from './MediaAudioVolumeAIcon';
export * from './MediaAudioVolumeAOffIcon';
export * from './MediaAudioVolumeS0Icon';
export * from './MediaAudioVolumeS1Icon';
export * from './MediaAudioVolumeS2Icon';
export * from './MediaAudioVolumeSMinusIcon';
export * from './MediaAudioVolumeSPlusIcon';
export * from './MediaAudioVolumeSXIcon';
export * from './MediaStreamCastIcon';
export * from './MediaStreamCastOffIcon';
export * from './MediaUiASkip2BackIcon';
export * from './MediaUiASkip2ForwardIcon';
export * from './NaturePlantFlowerIcon';
export * from './NaturePlantLeafIcon';
export * from './NaturePlantTreeAIcon';
export * from './NaturePlantTreeFirIcon';
export * from './NaturePlantTreePalmIcon';
export * from './NetConnectRssIcon';
export * from './NetConnectWifiIcon';
export * from './NetConnectWifiOffIcon';
export * from './NumberCircle00Icon';
export * from './NumberCircle01Icon';
export * from './NumberCircle02Icon';
export * from './NumberCircle03Icon';
export * from './NumberCircle04Icon';
export * from './NumberCircle05Icon';
export * from './NumberCircle06Icon';
export * from './NumberCircle07Icon';
export * from './NumberCircle08Icon';
export * from './NumberCircle09Icon';
export * from './People1BadgeIcon';
export * from './People1BossIcon';
export * from './People1CheckIcon';
export * from './People1EditIcon';
export * from './People1GearIcon';
export * from './People1Icon';
export * from './People1LockIcon';
export * from './People1MinusIcon';
export * from './People1PlusIcon';
export * from './People1XIcon';
export * from './People2Icon';
export * from './People3Icon';
export * from './PeopleCircle1Icon';
export * from './SettingsSlidersH3Icon';
export * from './SportBallBasketballIcon';
export * from './SportBallTennisIcon';
export * from './TechCamVideoIcon';
export * from './TechCamVideoOffIcon';
export * from './TechPcDesktopIcon';
export * from './TechPowerButtonIcon';
export * from './TechPowerPlugDiagIcon';
export * from './TechScreenMonitorIcon';
export * from './TechScreenMonitorOffIcon';
export * from './UiFrameSizeMaxIcon';
export * from './UiFrameSizeMinIcon';
export * from './UiMenuBars3HIcon';
export * from './UiMenuDots3HCircleIcon';
export * from './UiMenuDots3HIcon';
export * from './UiMenuDots3VIcon';
export * from './UiMenuDots8VIcon';
export * from './UiMenuDots9Icon';
export * from './UiMenuShapeCircle4Icon';
export * from './UiMenuShapeSquare4Icon';
export * from './UiMenuShapeSquare4TiltIcon';
export * from './UiMenuShapeSquare9Icon';
export * from './RotateSquareLeftIcon';
export * from './RotateSquareRightIcon';
export * from './CertRosetteAltIcon';
export * from './DataStructureTreeIcon';
export * from './DocCertIcon';
export * from './FolderCertIcon';
export * from './FoodWareDishIcon';
export * from './HandShakeIcon';
export * from './HorecaReceptionBellIcon';
export * from './LogoSlackIcon';
export * from './LogoThreadsIcon';
export * from './MarketRegisterAIcon';
export * from './MarketShoppingBagIcon';
export * from './SettingsSlidersH2Icon';
export * from './SportPersonFootballIcon';
export * from './SportPersonRunFastIcon';
export * from './SportPersonRunIcon';
export * from './TechPhoneFaxIcon';
export * from './TechPhoneSmartOffIcon';
export * from './TechScreenTabletHIcon';
export * from './TechScreenTabletVIcon';
export * from './TransportAirRocketIcon';
export * from './TransportAutoTruckIcon';
export * from './VisualEditContrastIcon';
export * from './WeatherMoonIcon';
export * from './WeatherSunIcon';
export * from './WeatherSunMoonIcon';
export * from './DataStructureGraphIcon';
export * from './NatureFxFireIcon';
export * from './HandPointButtonIcon';
export * from './HandPointClickAIcon';
export * from './HandPointClickBIcon';
export * from './HandPointIcon';
export * from './KonturFocusIcon';
export * from './LocationMapIcon';
export * from './LocationSignpostRightIcon';
export * from './NotificationAppIcon';
export * from './SecurityIncognitoMaskIcon';
export * from './SecurityIncognitoSpyIcon';
export * from './TextQuoteAIcon';
export * from './TimeClockStopwatchIcon';
export * from './UiCursorAClickIcon';
export * from './UiCursorAIcon';
export * from './UiCursorAMoveIcon';
export * from './UiCursorAWindowIcon';
export * from './FoodDrinkCupStrawIcon';
export * from './FoodDrinkCupTakeawayIcon';
export * from './FoodDrinkMilkIcon';
export * from './FoodDrinkWaterBottleIcon';
export * from './JewelDiamondIcon';
export * from './MedWheelchairIcon';
export * from './NatureFxLightningAIcon';
export * from './NatureFxLightningBIcon';
export * from './NatureFxWaterDropIcon';
export * from './SecurityFingerprintIcon';
export * from './TextArticleTIcon';
export * from './TransportPortableBicycleIcon';
export * from './BeautyCosmeticsPerfumeIcon';
export * from './ClothesAccsNecktieIcon';
export * from './ClothesShoesHighheelsIcon';
export * from './ClothesShoesSneakersIcon';
export * from './HousewareSoapLiquidIcon';
export * from './MedCrossIcon';
export * from './MedPillsBadIcon';
export * from './MedPillsIcon';
export * from './ScanFrameBarcodeDatamatrixIcon';
export * from './ScanFrameBarcodeQrIcon';
export * from './SportGymBarbellIcon';
export * from './DataChartBoardBarsIcon';
export * from './DevTerminalIcon';
export * from './KonturBonusSignIcon';
export * from './TargetCrosshairIcon';
export * from './TargetRadialIcon';
export * from './TechKeyboardIcon';
export * from './TechStorageUsbOffIcon';
export * from './WeatherSnowflakeIcon';
export * from './WeatherThermometerIcon';
export * from './ArrowDim4CrossDiagIcon';
export * from './ArrowDim4CrossIcon';
export * from './GovHeraldRuEagleIcon';
export * from './GovKoFnsIcon';
export * from './LogoSbpIcon';
export * from './GovKoRarIcon';
export * from './GovKoRosreestrIcon';
export * from './GovKoSfrIcon';
export * from './ShapeCircleMsIcon';
export * from './CelebrationBalloonIcon';
export * from './KonturZakupkiIcon';
export * from './MediaAudioMicAIcon';
export * from './MediaAudioMicAOffIcon';
export * from './MediaAudioWaveIcon';
export * from './SecurityPasswordInputIcon';
export * from './SecuritySafeIcon';
export * from './TechCamPhotoOffIcon';
export * from './WeatherUmbrellaIcon';
export * from './LogoMattermostIcon';
export * from './NatureFxSparkleA1Icon';
export * from './NatureFxSparkleA2Icon';
export * from './NatureFxSparkleA3Icon';
